import { Button, Control, Fieldset, Field, Label, Input } from "rbx";
import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";

import { toast } from "react-toastify";
import { useQuery, useMutation } from "react-apollo";
import Section from "../Section";
import { MAX_DRIVER_WEIGHT, MIN_DRIVER_WEIGHT } from "../../constants";
import {
  SINGLE_EMPLOYEE_QUERY,
  UPDATE_EMPLOYEE_MUTATION
} from "../../graphql/Employees/Employees.graphql";

const EmployeeWeightModal = ({ driver, onComplete }) => {
  const [loading, setLoading] = useState(false);
  const [driverWeight, setDriverWeight] = useState(MIN_DRIVER_WEIGHT);

  const { data: EmployeeData } = useQuery(SINGLE_EMPLOYEE_QUERY, {
    variables: { where: { RecId: driver.Employee.RecId } }
  });

  const [updateEmployee] = useMutation(UPDATE_EMPLOYEE_MUTATION, {
    refetchQueries: [
      {
        query: SINGLE_EMPLOYEE_QUERY,
        variables: { where: { RecId: driver.Employee.RecId } }
      }
    ]
  });

  const handleSubmit = async e => {
    e.preventDefault();

    try {
      setLoading(true);
      const [fName, lName] = driver.Employee.FullName.split(" ");
      await updateEmployee({
        variables: {
          data: {
            FirstName: fName,
            LastName: lName,
            Weight: parseFloat(driverWeight)
          },
          where: { RecId: parseInt(driver.Employee.RecId) }
        }
      });
      toast.success("Driver weight updated successfully.");
      onComplete();
    } catch (err) {
      toast.error(err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (EmployeeData?.Employee?.Weight) {
      setDriverWeight(EmployeeData.Employee.Weight);
    }
  }, [EmployeeData]);

  const handleChange = (name, value) => {
    setDriverWeight(value);
  };

  const isDisabled =
    loading ||
    !driverWeight ||
    driverWeight < MIN_DRIVER_WEIGHT ||
    driverWeight > MAX_DRIVER_WEIGHT;

  return (
    <Section title={driver?.Employee?.FullName}>
      <form id="edit-driver-weight-form" onSubmit={handleSubmit}>
        <Fieldset>
          <Control>
            <Label>Weight</Label>
            <Input
              id="weight"
              max={MAX_DRIVER_WEIGHT}
              min={MIN_DRIVER_WEIGHT}
              name="DriverWeight"
              step="1"
              type="number"
              value={driverWeight}
              onChange={e => handleChange(e.target.name, e.target.value)}
              onKeyPress={event => {
                if (!/[0-9]/.test(event.key)) {
                  event.preventDefault();
                }
              }}
            />
          </Control>
          <hr />
          <Field kind="group">
            <Control>
              <Button
                color="success"
                disabled={isDisabled}
                form="edit-driver-weight-form"
                state={loading ? "loading" : ""}
                type="submit"
              >
                Save
              </Button>
            </Control>
            <Control>
              <Button disabled={loading} type="button" onClick={onComplete}>
                Cancel
              </Button>
            </Control>
          </Field>
        </Fieldset>
      </form>
    </Section>
  );
};

EmployeeWeightModal.propTypes = {
  driver: PropTypes.object,
  onComplete: PropTypes.func
};
export default EmployeeWeightModal;
